import { atom } from "recoil";

export const speechTextState = atom({
  key: "speechTextState",
  default: { text: "" },
});
